export class ErrorMessages {
  static readonly UNEXPECTED_ERROR =
    "An unexpected error has occurred. Our team is working to resolve this issue as quickly as possible. Please try again later.";
  static readonly INACTIVE_LEAD_WARNING =
    "This lead is not currently active. Any communications with this lead will not be sent to the OEM.";
  static readonly REPAIR_ORDER_TEXTING_DISABLED =
    "Texting disabled when looking at Repair Orders";
  static readonly PENDING_CUSTOMER_OPT_IN_WARNING = "Pending Customer Opt-In";
  static readonly CONTACT_DETAILS_UNAVAILABLE =
    "Contact information is currently unavailable. Sending messages is disabled.";
  static readonly MESSAGE_HISTORY_UNAVAILABLE =
    "Message history currently unavailable. Our team has been notified and is working to resolve the issue. Please try again later.";
  static readonly MESSAGE_DETAILS_UNAVAILABLE =
    "Message details currently unavailable. Our team has been notified and is working to resolve the issue. Please try again later.";
  static readonly ATTACHMENT_DOWNLOAD_FAILED =
    "The attachment could not be downloaded. Our team has been notified and is working to resolve the issue. Please try again later.";
  static readonly LEAD_STATUS_UNAVAILABLE =
    "Currently unable to get lead status. Any communications with this lead may not be sent to the OEM.";

  static readonly INVALID_EMAIL_ADDRESS_ERROR = "⚠ Invalid email address";
  static readonly DUPLICATE_EMAIL_ADDRESS_ERROR =
    "⚠ Email address already added";
  static readonly MAX_RECIPIENTS_ERROR =
    "⚠ Maximum of {maxRecipients} recipients allowed";
  // Emoji Picker Error Messages
  static readonly EMOJI_PICKER_LOAD_ERROR =
    "Unable to load emoji picker. Please refresh and try again.";

  // Dealer Phone Validation Alert Messages
  static readonly DEALER_PHONE_CAMPAIGN_NOT_APPROVED_TITLE =
    "Campaign Not Approved";
  static readonly DEALER_PHONE_CAMPAIGN_NOT_APPROVED_MESSAGE =
    "Texting Registration is not approved. Please contact your administrator.";
  static readonly DEALER_PHONE_NUMBER_NOT_READY_TITLE =
    "Phone Number Not Ready";
  static readonly DEALER_PHONE_NUMBER_NOT_READY_MESSAGE =
    "The selected phone number is not ready for texting. Please contact your administrator.";
  static readonly DEALER_PHONE_TEXTING_UNAVAILABLE_TITLE =
    "Texting Unavailable";
  static readonly DEALER_PHONE_TEXTING_UNAVAILABLE_MESSAGE =
    "Texting is currently unavailable. Unable to retrieve dealer phone information.";

  // Media Endlink Error Messages
  static readonly MEDIA_ENDLINK_ERROR =
    "Unable to insert media. Please try again.";

  // Vehicle Insert Error Messages
  static readonly VEHICLE_INSERT_NOT_FOUND_ERROR =
    "Error retrieving {vehicleType}. Please check the lead for vehicle information.";
  static readonly VEHICLE_INSERT_GENERIC_ERROR =
    "Error retrieving {vehicleType}. Please try again.";

  // Signature Insert Error Messages
  static readonly SIGNATURE_NOT_FOUND =
    "You don't have a signature set up. Please check your settings in VinSolutions.";
  static readonly SIGNATURE_FETCH_ERROR =
    "Error retrieving signature. Please try again.";

  // Template Token Replacement Error Messages
  static readonly TOKEN_REPLACEMENT_WARNING =
    "There was an error automatically replacing tokens. Please update and review before sending.";

  // HTTP Status Code Error Messages
  static readonly BAD_REQUEST_ERROR =
    "The request could not be processed. Please check your input and try again.";
  static readonly UNAUTHORIZED_ERROR =
    "You are not authorized to access this resource. Please log in and try again.";
  static readonly FORBIDDEN_ERROR =
    "You do not have permission to access this resource. Please contact your administrator if you believe this is an error.";
  static readonly NOT_FOUND_ERROR =
    "The requested information could not be found. It may have been moved or deleted.";
  static readonly SERVER_ERROR =
    "A server error occurred. Our team has been notified and is working to resolve the issue. Please try again later.";
  static readonly SERVICE_UNAVAILABLE_ERROR =
    "The service is temporarily unavailable. Please try again in a few moments.";
  static readonly GATEWAY_ERROR =
    "Unable to connect to the service. Please check your connection and try again.";
}
